import Tab from '@mui/material/Tab'
import MuiTabs, {TabsProps} from '@mui/material/Tabs'
import {tabList} from 'entities/searchPeople/config'
import './styles.scss'
import {names} from 'shared/lib'

export const Tabs: React.FC<TabsProps> = ({className, ...rest}) => {
  return (
    <MuiTabs
      classes={{flexContainer: 'flexContainer', root: names('tabs', className)}}
      {...rest}
    >
      {tabList.map((tab) => <Tab value={tab.id} key={tab.id} label={tab.label} />)}
    </MuiTabs>
  )
}
